import { BundleGroupWsDTO } from '../../model/bundles.model';
import { Observable } from 'rxjs';
import { Occ } from '@spartacus/core';
import CartModification = Occ.CartModification;

export abstract class GgProductBundlesAdapter {
  abstract addBundleToCart(cartId: string, userId: string, bundleGroup: BundleGroupWsDTO): Observable<CartModification>;
  abstract removeBundleFromCart(userId: string, cartId: string, entryNumbers: number[]): Observable<any>;
}
